// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vBWDG","title":"styles_title__hCm2t","description":"styles_description__DkLe5"};